import { topicsData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm">实时追踪最热吃瓜话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200"
            >
              <span className={`inline-block px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap ${tagColors[topic.color]}`}>
                {topic.tag}
              </span>
              <span className="text-foreground-700 text-sm font-medium whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-foreground-400 text-xs whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}